<template>
    <div>
        <c-panel>
            <el-form>
                <el-row :gutter="10" class="u-mb-10">
                    <el-col :xs="24" :sm="4" :md="4">
                        <el-form-item label="Nº matrícula" prop="num_matricula" key="num_matricula">
                            <el-input size="small" v-model="filtro.num_matricula" placeholder="" @keyup.native.enter="changeInputFiltroNumMatricula"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4" :md="4">
                        <el-form-item label="Cod. Transferência" prop="cod_transferencia" key="cod_transferencia">
                            <el-input size="small" v-model="filtro.cod_transferencia" placeholder="" @keyup.native.enter="changeInputFiltroCodTransferencia"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4" :md="4">
                        <el-form-item label="INEP" prop="inep" key="inep">
                            <el-input size="small" v-model="filtro.inep" placeholder="" @keyup.native.enter="changeInputFiltroInep"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4" :md="4">
                        <el-form-item label="CPF" prop="documento" key="documento">
                            <el-input size="small" v-model="filtro.documento" v-mask="'###.###.###-##'" placeholder="" @keyup.native.enter="changeInputFiltroDocumento"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Nome do aluno" prop="nome" key="nome">
                            <el-input size="small" v-model="filtro.nome" placeholder="" @keyup.native.enter="changeInputFiltroNomeOrMae"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Filiação 1" prop="mae" key="mae">
                            <el-input size="small" v-model="filtro.mae" placeholder="" @keyup.native.enter="changeInputFiltroNomeOrMae"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4" :md="4">
                        <el-form-item label="Situação da Matrícula" prop="situacao_matricula" key="situacao_matricula">
                            <el-select size="small" v-model="filtro.situacao_matricula" @change="changeSituacaoMatricula" clearable>
                                <el-option :key="1" label="ATIVO" :value="1"> </el-option>
                                <el-option :key="0" label="PENDENTE" :value="0"> </el-option>
                                <el-option :key="2" label="EM TRANSFERÊNCIA" :value="2"> </el-option>
                                <el-option :key="10" label="EVADIDO" :value="10"> </el-option>
                                <el-option :key="11" label="DESISTENTE" :value="11"> </el-option>
                                <el-option :key="15" label="AGENDADO" :value="15"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="($store.state.config.parametros.fase_matricula != 1 && $store.state.config.parametros.fase_matricula != 2) ? 11 : 14" :md="($store.state.config.parametros.fase_matricula != 1 && $store.state.config.parametros.fase_matricula != 2) ? 11 : 14">
                        <el-form-item label="Instituicao" prop="instituicao_id" key="instituicao_id">
                            <el-select size="small" v-model="filtro.instituicao_id" @change="changeFiltro" filterable clearable>
                                <el-option key="all" label="- TODAS AS INSTITUIÇÕES -" value=""> </el-option>
                                <el-option v-for="(item, i) in instituicoes" :key="i" :label="$store.state.config.periodo.nome + ' - ' + item.nome" :value="item.id"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="$store.state.user.tipo == 4 || $store.state.user.tipo == 6 || $store.state.user.tipo < 2" :xs="24" :sm="3" :md="3" class="u-text-right">
                        <router-link to="/admin/matricula/passo-a-passo" style="display: block;">
                            <el-button size="small" style="margin-top: 18px;" type="primary" plain>
                                <i class="fas fa-plus u-mr-5"></i>
                                NOVO ALUNO
                            </el-button>
                        </router-link>
                    </el-col>               
                   
                </el-row>
            </el-form>
            <div class="container-table u-mt-10">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th class="hidden-mobile" style="width: 90px;">Matrícula</th>
                            <th>Nome</th>
                            <th>Data de Nascimento</th>
                            <th>Curso / Turma</th>
                            <th>Turno</th>                            
                            <th v-if="!filtro.instituicao_id">Instituição em {{ $store.state.config.periodo.nome }}</th>
                            <th class="u-text-center">Situação da Matrícula</th>
                            <th v-if="$store.state.user.tipo != 10" style="width: 120px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="item in items" :key="item.id" v-bind:class="{ 'st-mt-pendente': (item.matriculas.length > 0 && item.matriculas[0].situacao_matricula == 0 ? true : false),
                                'st-mt-matriculada': (item.matriculas.length > 0 && (item.matriculas[0].situacao_matricula == 1 || item.matriculas[0].situacao_matricula == 13) && ($store.state.config.parametros.fase_matricula == 1 || $store.state.config.parametros.fase_matricula == 2) ? true : false),
                                'st-mt-agendada': (item.matriculas.length > 0 && item.matriculas[0].situacao_matricula == 15 && ($store.state.config.parametros.fase_matricula == 1 || $store.state.config.parametros.fase_matricula == 2 || $store.state.config.parametros.fase_matricula == 3) ? true : false)
                            }">
                            <td class="hidden-mobile">{{ item.num_matricula }}</td>
                            <td>
                                <a @click="openDossieAluno(item)" title="Abrir dossiê do aluno" href="javascript:void(0)">
                                    <b class="hidden-desktop">NOME:</b> {{ item.nome_social_aluno ? item.nome + ' – ' + item.nome_social_aluno : item.nome }}<br>
                                </a>
                                <span v-if="item.mae" class="nm-mae">Filiação 1: {{ item.mae.toLowerCase() }}</span>
                            </td>
                            <td><b class="hidden-desktop">DATA NASC.:</b> {{ (item.data_nascimento) ? $moment(item.data_nascimento).format('DD/MM/YYYY') : '-' }}</td>
                            <td>
                                <span v-if="item.matriculas.length > 0">

                                    {{ (item.matriculas[0].turma && item.matriculas[0].turma.curso ? item.matriculas[0].turma.curso.nome.toUpperCase() : '') }}

                                    <span v-if="!item.matriculas[0].turma || (item.matriculas[0].turma && (item.matriculas[0].turma.curso_id == 89 || item.matriculas[0].turma.curso_id == 19 || item.matriculas[0].turma.curso_id == 18))">
                                        {{ item.matriculas[0].curso.nome.toUpperCase() }}
                                    </span>

                                    {{ (item.matriculas[0].turma) ? ' / ' + item.matriculas[0].turma.nome : '' }}

                                </span>
                                <span v-else>
                                    -
                                </span>
                            </td>
                            <td >
                                <b class="hidden-desktop">TURNO:</b>
                                {{ (item.matriculas.length > 0 && item.matriculas[0].turma) ? $CONSTANTS.TURNO[item.matriculas[0].turma.turno] : '-' }}
                                <br>                               
                            </td>                          
                            <td v-if="!filtro.instituicao_id"><b class="hidden-desktop">INSTITUIÇÃO:</b>

                                {{ (item.matriculas.length > 0) ? item.matriculas[0].instituicao.apelido : '-' }}<br>


                            </td>
                            <td class="u-text-center">
                                <b class="hidden-desktop">SITUAÇÃO:</b>
                                {{ (item.matriculas.length > 0) ? $CONSTANTS.SITUACAO_MATRICULA[item.matriculas[0].situacao_matricula] : '-' }}
                                <br>
                                <!-- <el-tag v-if="item.matriculas.length > 0 && item.matriculas[0].situacao_matricula == 1 && !item.matriculas[0].educacenso_2021" type="danger" style="margin-top: 5px;">
                                    Fora da 1ª Etapa do Censo 2021
                                </el-tag> -->
                            </td>
                            <td class="u-text-center acao" v-if="$store.state.user.tipo != 10">

                                <el-button class="u-mr-5" v-if="$store.state.user.tipo == 4" @click="openDeleteAluno(item)" title="Excluir" type="danger" icon="el-icon-delete" size="mini"></el-button>
                        
                                <el-button disabled title="Aluno vinculado a outra instituição" type="info" icon="el-icon-menu" size="mini" plain v-if="item.falecido || (item.matriculas.length > 0 && $store.state.config.instituicao.id != item.matriculas[0].instituicao.id && $store.state.user.tipo != 4 && $store.state.user.tipo != 6 && item.matriculas[0].situacao_matricula != 2 && item.matriculas[0].situacao_matricula != 10 && item.matriculas[0].situacao_matricula != 11)"></el-button>

                                <el-popover placement="left" v-if="!item.falecido &&
                                    ((item.matriculas.length > 0 && ($store.state.config.instituicao.id == item.matriculas[0].instituicao.id || item.matriculas[0].situacao_matricula == 2 || item.matriculas[0].situacao_matricula == 10 || item.matriculas[0].situacao_matricula == 11)) ||
                                     item.matriculas.length == 0 ||
                                     $store.state.user.tipo == 4 ||
                                     $store.state.user.tipo == 6
                                    )">
                                    <ul class="list-acoes">

                                        <li @click="openModalRenovarMatricula(item)" v-if="
                                            item.matriculas.length > 0 && item.matriculas[0].situacao_matricula == 0 &&
                                            ($store.state.user.tipo <= 1 || $store.state.user.tipo == 4 || $store.state.user.tipo == 6)"
                                        ><i class="fas fa-arrow-circle-up"></i>
                                            Renovar Matrícula
                                        </li>

                                        <li @click="editarAluno(item.id)" v-if="
                                            ($store.state.user.tipo <= 1 && item.matriculas.length > 0 && item.matriculas[0].situacao_matricula == 1) ||
                                            $store.state.user.tipo == 4 || $store.state.user.tipo == 6"
                                        ><i class="fas fa-arrow-circle-up"></i>
                                            Editar Aluno
                                        </li>
                                        
                                        <li @click="novaMatricula(item)" v-if="

                                            //condição 1 - instituição que participa da pré-matrícula e que possuem alunos agendados
                                            
                                            (
                                                ($store.state.config.parametros.fase_matricula == 3) &&
                                                $store.state.user.tipo <= 1 && $store.state.config.instituicao.participa_pre_matricula && (
                                                    item.matriculas.length == 0 || 
                                                    (
                                                        item.matriculas.length > 0 &&
                                                        (
                                                            item.matriculas[0].situacao_matricula == 2 ||  //EM TRANSFERÊNCIA
                                                            item.matriculas[0].situacao_matricula == 10 || //EVADIDO
                                                            item.matriculas[0].situacao_matricula == 11    //DESISTENTE
                                                        )
                                                    )
                                                )
                                            ) ||
                                            

                                            //condição 2 - instituição que não participa da pré-matrícula
                                            (
                                                ($store.state.config.parametros.fase_matricula == 2 || $store.state.config.parametros.fase_matricula == 3) &&
                                                $store.state.user.tipo <= 1 && !$store.state.config.instituicao.participa_pre_matricula && (
                                                    item.matriculas.length == 0 || 
                                                    (
                                                        item.matriculas.length > 0 &&
                                                        (
                                                            item.matriculas[0].situacao_matricula == 2 ||  //EM TRANSFERÊNCIA
                                                            item.matriculas[0].situacao_matricula == 10 || //EVADIDO
                                                            item.matriculas[0].situacao_matricula == 11    //DESISTENTE
                                                        )
                                                    )
                                                )
                                            
                                            ) ||                                           

                                            //condição 3 - SMED e NTI
                                            (
                                                ($store.state.user.tipo == 4 || $store.state.user.tipo == 6) && (
                                                    item.matriculas.length == 0 ||
                                                    (
                                                        item.matriculas.length > 0 &&
                                                        (
                                                            item.matriculas[0].situacao_matricula == 2 ||  //EM TRANSFERÊNCIA
                                                            item.matriculas[0].situacao_matricula == 10 || //EVADIDO
                                                            item.matriculas[0].situacao_matricula == 11 || //DESISTENTE
                                                            item.matriculas[0].situacao_matricula == 15    //AGENDADO
                                                        )   
                                                    )
                                                )
                                            )
                            
                                            "
                                        ><i class="fas fa-arrow-circle-up"></i>
                                            Matricular Aluno
                                        </li>
                                        
                                        <li @click="colocarAlunoTransferencia(item)" v-if="
                                            (item.matriculas.length > 0 &&
                                            (item.matriculas[0].situacao_matricula == 0 ||
                                            item.matriculas[0].situacao_matricula == 1 ||
                                            item.matriculas[0].situacao_matricula == 13 ||
                                            item.matriculas[0].situacao_matricula == 10)) &&
                                            (($store.state.user.tipo <= 1 && 
                                            $store.state.config.instituicao.id == item.matriculas[0].instituicao.id) ||
                                            $store.state.user.tipo == 4 || $store.state.user.tipo == 6)"
                                        ><i class="fas fa-arrow-circle-up"></i>
                                            Colocar aluno em transferência
                                        </li>
                                        

                                        <li @click="openDossieAluno(item)">
                                            <i class="fas fa-arrow-circle-up"></i>
                                            Abrir dossiê do Aluno
                                        </li>

                                        <!-- <li 
                                            v-if="
                                                (item.matriculas.length > 0 &&
                                                (item.matriculas[0].situacao_matricula == 2 ||
                                                item.matriculas[0].situacao_matricula == 4)) &&
                                                ($store.state.user.tipo == 0 && $store.state.config.instituicao.id == item.matriculas[0].instituicao.id)"
                                            @click="printHistoricoEscolar(item)"
                                        >
                                            <i class="fas fa-arrow-circle-up"></i>
                                            Imprimir histórico escolar
                                        </li> -->

                                        <li v-if="[0, 1, 4, 5, 6].includes(Number($store.state.user.tipo))" @click="excluirAluno(item)" style="color: #ff0000">
                                            <i class="fas fa-arrow-circle-up"></i>
                                            Excluir aluno
                                        </li>

                                    </ul>
                                    <el-button slot="reference" title="Mais ações" type="primary" icon="el-icon-menu" size="mini" plain></el-button>
                                </el-popover>

                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25">
                    <img src="/public/img/loading-bar.gif" />
                </div>
                <el-row :gutter="10" v-if="statusList">
                    <el-col :xs="24" :sm="12" :md="12">
                        <div class="u-text-left u-mt-10">
                            Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
                        <div class="u-text-right">
                                <el-pagination :current-page='paginate.page' class="u-mt-10" :total="paginate.qtdItens" @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                            </div>
                    </el-col>
                </el-row>
            </div>
        </c-panel>

        <el-dialog :close-on-click-modal="false" title="DOSSIÊ DO ALUNO" width="90%" top="40px" :visible.sync="dialogDossieAluno" v-on:close="closeDialogDossieAluno">
            <div v-if="dialogDossieAluno" style="margin-top: 20px;">
                <dossie-aluno :id="alunoSelected.id" v-on:changeDossie="changeDossie"></dossie-aluno>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="RENOVAÇÃO DE MATRÍCULA" width="90%" top="40px" :visible.sync="dialogRenovacaoMatricula" v-on:close="closeDialogRenovacaoMatricula">
            <div v-if="dialogRenovacaoMatricula" style="margin-top: 20px;">
                <renovacao :aluno="alunoSelected.id" v-on:closeModal="closeDialogRenovacaoMatricula"></renovacao>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :show-close="false" :modal-append-to-body="false" title="DECLARAÇÃO" width="80%" :visible.sync="dialogTextoDeclaracao">
            <div v-if="dialogTextoDeclaracao" style="margin-top: 20px;">
                <texto-declaracao :matricula="matriculaSelected.id" v-on:closeModal="closeModalTextoDeclaracao"></texto-declaracao>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="EXCLUSÃO DE ALUNO" width="80%" top="40px" :visible.sync="dialogDeleteAluno" v-on:close="closeDialogDeleteAluno">
            <div v-if="dialogDeleteAluno" style="margin-top: 20px;">
                <exclusao-aluno :aluno="alunoSelected" v-on:closeModal="closeDialogDeleteAluno" />
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="IMPRESSÃO HISTÓRICO ESCOLAR" width="80%" top="40px" :visible.sync="dialogHistoricoEscolar" v-on:close="closeDialogHistoricoEscolar">
            <div v-if="dialogHistoricoEscolar" style="margin-top: 20px;">
                <historico-escolar :aluno="alunoSelected" v-on:closeModal="closeDialogHistoricoEscolar" />
            </div>
        </el-dialog>

    </div>
</template>
<script>

import renovacao from '@/components/matricula/renovacao/renovacao'
import dossieAluno from '@/components/aluno/dossie'
import textoDeclaracao from '@/components/matricula/transferencia/texto-declaracao'
import exclusaoAluno from '@/components/aluno/exclusao-aluno'
import historicoEscolar from '@/components/diario/historico-escolar'
export default {
    data: () => ({
        alunoSelected: {},
        matriculaSelected: {},
        dialogDeleteAluno: false,
        dialogRenovacaoMatricula: false,
        dialogDossieAluno: false,
        dialogTransporte: false,
        dialogRemanejar: false,
        dialogDetalhesMatricula: false,
        dialogTextoDeclaracao: false,
        dialogHistoricoEscolar: false,
        statusList: false,
        filtro: {
            num_matricula: '',
            cod_transferencia: '',
            inep: '',
            nome: '',
            documento: '',
            mae: '',
            situacao_matricula: '',
            instituicao_id: ''
        },
        paginate: {
            page: 1,
            qtdItens: null,
            from: '',
            to: ''
        },
        items: [ ],
        instituicoes: [],

    }),
    mounted () {

        if([0, 1, 3, 12].includes(Number(this.$store.state.user.tipo)) && this.$store.state.config.instituicao){

            this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
            this.instituicoes.push({ id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome });

        }else{

            this.instituicoes = this.$store.state.instituicoes;
        }

        this.loadingAlunos()
    },
    methods: {
        excluirAluno(item) {

            this.$msgbox.confirm(`Tem certeza que deseja excluir o aluno ${item.nome}?`, 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {
                
                window.eventBus.$emit('loading', true)

                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/aluno/delete/` + item.id, this.$store.getters.getHeaderAuth).then(() => {

                    window.eventBus.$emit('loading', false)
                    window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
                    this.loadingAlunos();

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })

            }).catch(() => { })

        },
        openDeleteAluno(item){

            this.dialogDeleteAluno = true;
            this.alunoSelected = item;
        },
        closeDialogDeleteAluno(){
            this.loadingAlunos()
            this.dialogDeleteAluno = false;
            this.alunoSelected = {};
        },
        loadingAlunos(){

            this.statusList = false;
            this.items = [];

            this.filtro.nome = this.$removerAcentos(this.filtro.nome).toUpperCase();
            let p = this.$store.state.config.periodo.id;

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/aluno/getAllPaginate/${p}?page=` + this.paginate.page, this.filtro, this.$store.getters.getHeaderAuth).then(response => {

                this.items = response.data.data;
                this.paginate.qtdItens = response.data.total;
                this.paginate.from = response.data.from;
                this.paginate.to = response.data.to;
                this.statusList = true;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        changeDossie(actions){

            if(actions.loading){

                this.loadingAlunos();
            }

            if(actions.close){

                this.dialogDossieAluno = false;
            }
        },
        changeSituacaoMatricula(){

            if(this.$store.state.user.tipo <= 1 && this.$store.state.config.instituicao){

                this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
            }

            this.changeFiltro();
        },
        changeInputFiltroNomeOrMae(){

            this.filtro.instituicao_id = '';
            this.filtro.inep = '';
            this.filtro.num_matricula = '';
            this.filtro.documento = '';
            this.filtro.cod_transferencia = '';
            this.filtro.situacao_matricula = '';
            this.changeFiltro();
        },
        changeInputFiltroDocumento(){

            this.filtro.num_matricula = '';
            this.filtro.cod_transferencia = '';
            this.filtro.inep = '';
            this.filtro.nome = '';
            this.filtro.mae = '';
            this.filtro.instituicao_id = '';
            this.filtro.situacao_matricula = '';
            this.changeFiltro();
        },
        changeInputFiltroCodTransferencia(){

            this.filtro.num_matricula = '';
            this.filtro.documento = '';
            this.filtro.inep = '';
            this.filtro.nome = '';
            this.filtro.mae = '';
            this.filtro.instituicao_id = '';
            this.filtro.situacao_matricula = '';
            this.changeFiltro();

        },
        changeInputFiltroNumMatricula(){

            this.filtro.inep = '';
            this.filtro.nome = '';
            this.filtro.documento = '';
            this.filtro.cod_transferencia = '';
            this.filtro.mae = '';
            this.filtro.instituicao_id = '';
            this.filtro.situacao_matricula = '';
            this.changeFiltro();
        },
        changeInputFiltroInep(){

            this.filtro.num_matricula = '';
            this.filtro.nome = '';
            this.filtro.documento = '';
            this.filtro.cod_transferencia = '';
            this.filtro.mae = '';
            this.filtro.instituicao_id = '';
            this.filtro.situacao_matricula = '';
            this.changeFiltro();
        },
        changeFiltro(){

            this.paginate.page = 1;
            this.loadingAlunos();
        },
        colocarAlunoTransferencia(aluno){

            this.$msgbox.confirm(`Tem certeza que deseja colocar o aluno ${aluno.nome} em transferência?`, 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);

                let p = this.$store.state.config.periodo.id;

                this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/matricula/storeTransferencia/${p}/${aluno.id}/0`, this.$store.getters.getHeaderAuth).then(response => {

                    if(typeof response.data.throw !== 'undefined'){

                        this.$alert(response.data.throw.msg, 'Atenção', {
                            confirmButtonText: 'OK',
                            type: response.data.throw.type,
                            center: true
                        }).catch(()=>{});

                    }else{

                        this.matriculaSelected = response.data;
                        this.dialogTextoDeclaracao = true;
                    }

                    window.eventBus.$emit('loading', false);
                });

            }).catch(()=>{});
        },
        closeModalTextoDeclaracao(){

            this.matriculaSelected = {};
            this.dialogTextoDeclaracao = false;
            this.loadingAlunos();

        },
        cancelarMatricula(id){

            this.$msgbox.confirm('Tem certeza que deseja cancelar a matrícula deste aluno?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/matricula/cancelarMatricula/` + id, {}, this.$store.getters.getHeaderAuth).then(response => {

                    if(typeof response.data.erro !== 'undefined'){

                        window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});
                        window.eventBus.$emit('loading', false);

                    }else{

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.openDossieAluno(this.alunoSelected);
                        this.loadingAlunos();
                    }

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});

        },
        editarAluno(item){

            this.$router.push('/admin/aluno/edit/'+ item);
        },
        novaMatricula(item){

            for(let i in item.matriculas){

                if(item.matriculas[i].situacao_matricula == '0' || item.matriculas[i].situacao_matricula == '1'){

                    window.eventBus.$emit('alert', {msg: 'O aluno já possui vínculo de matrícula no sistema.', type: 'warning'});
                    return false;
                }
            }

            this.$router.push('/admin/matricula/passo-a-passo/' + item.id);
        },
        calculaIdade(dtNascimento) {   
    
            return this.$moment(`2024-03-31`).diff(
                dtNascimento,
                "years"
            );
        
        },
        openDossieAluno(item){

            this.dialogDossieAluno = true;
            this.alunoSelected = item;

        },
        getPagePagination(page){
          this.paginate.page = page;
          this.loadingAlunos();
        },
        closeDialogDossieAluno(){

            this.alunoSelected = {  };
        },
        openModalRenovarMatricula(aluno){

            this.alunoSelected = aluno;
            this.dialogRenovacaoMatricula = true;
        },
        closeDialogRenovacaoMatricula(){

            this.loadingAlunos()
            this.dialogRenovacaoMatricula = false;
            this.alunoSelected = {  };
        },
        printHistoricoEscolar(item){

            this.dialogHistoricoEscolar = true;
            this.alunoSelected = item;

        },
        closeDialogHistoricoEscolar () {
            this.dialogHistoricoEscolar = false;
            this.alunoSelected = {};
        }
    },

    components:{ dossieAluno, renovacao, textoDeclaracao, exclusaoAluno, historicoEscolar }
}
</script>